module.exports = __webpack_public_path__ + "static/media/calendar-gold.39a51dde.svg";